import { toArray, sum, map, pipe, filter } from 'lodash/fp';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { compose, withHandlers, withPropsOnChange, lifecycle, withProps } from 'recompose';
import { getBrandId } from '../../../../../auth/selectors';
import { fetchSettings } from '../../../Shopify/reducer/actions';
import { productFormValueSelector } from '../../SharedForm/formConfig';

export const getAssignedTotal = pipe(
  toArray,
  filter('enabled'),
  map('inventory'),
  map(value => (value ? Number(value) : 0)),
  sum,
);

const InventoryStepContainer = compose(
  connect(
    state => ({
      brandId: getBrandId(state),
      allEnabled: productFormValueSelector(state, 'allEnabled'),
      assignmentValues: productFormValueSelector(state, 'assignments'),
      assignedTotal: getAssignedTotal(productFormValueSelector(state, 'assignments')),
      price: productFormValueSelector(state, 'price'),
      locationPrice: productFormValueSelector(state, 'locationPrice'),
      inventory: productFormValueSelector(state, 'inventory'),
      unallocatedInventory: productFormValueSelector(state, 'unallocatedInventory'),
      lowInventoryThreshold: productFormValueSelector(state, 'lowInventoryThreshold'),
      highInventoryThreshold: productFormValueSelector(state, 'highInventoryThreshold'),
      shopifySettings: state.shopify.shopifySettings.settings,
    }),
    { fetchSettings }
  ),
  withProps((props) => {
    const overrides = Object.entries(props.assignmentValues).reduce((changes, [assignmentId, assignment]) => {
      if (assignment.price !== props.price) {
        // eslint-disable-next-line no-param-reassign
        changes[assignmentId] = { price: assignment.price };
      }

      if (assignment.lowInventoryThreshold !== props.lowInventoryThreshold) {
        if (changes[assignmentId]) {
          // eslint-disable-next-line no-param-reassign
          changes[assignmentId].lowInventoryThreshold = assignment.lowInventoryThreshold;
        } else {
          // eslint-disable-next-line no-param-reassign
          changes[assignmentId] = { lowInventoryThreshold: assignment.lowInventoryThreshold };
        }
      }

      if (assignment.highInventoryThreshold !== props.highInventoryThreshold) {
        if (changes[assignmentId]) {
          // eslint-disable-next-line no-param-reassign
          changes[assignmentId].highInventoryThreshold = assignment.highInventoryThreshold;
        } else {
          // eslint-disable-next-line no-param-reassign
          changes[assignmentId] = { highInventoryThreshold: assignment.highInventoryThreshold };
        }
      }

      return changes;
    }, {});

    return {
      overrides,
      hasOverrides: Object.keys(overrides).length > 0,
    };
  }),
  withHandlers({
    toggleLocations: props => () => {
      props.product.assignments.forEach((assignment) => {
        props.change(`assignments.${assignment.ownerId}.enabled`, !props.allEnabled);
      });
    },
    toggleLocation: props => (ownerId) => {
      const targetAssignment = get(props, ['assignmentValues', ownerId]);
      const isNotEmptyAndNotZero = !targetAssignment.inventory && targetAssignment.inventory !== 0;

      if (!targetAssignment.enabled && isNotEmptyAndNotZero) {
        props.change(`assignments.${ownerId}.inventory`, 0);
      }
    },
  }),
  withPropsOnChange(
    (prevProps, nextProps) => (
      prevProps.assignedTotal !== nextProps.assignedTotal
    ),
    (props) => {
      const allocatedInventory = props.assignedTotal;
      if (allocatedInventory <= Number(props.inventory)) {
        props.change('unallocatedInventory', props.inventory - allocatedInventory);
      }
    }
  ),
  withPropsOnChange(
    ['price'],
    (props) => {
      props.change('locationPrice', props.price);
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchSettings(this.props.brandId);

      if (this.props.initialValues.price !== this.props.price) {
        this.props.product.assignments.forEach((assignment) => {
          if (
            assignment.price === undefined
            || assignment.price === null
            || assignment.price === this.props.initialValues.price
          ) {
            this.props.change(`assignments.${assignment.ownerId}.price`, this.props.price);
          }
        });
      }

      if (this.props.initialValues.highInventoryThreshold !== this.props.highInventoryThreshold) {
        this.props.product.assignments.forEach((assignment) => {
          if (
            assignment.highInventoryThreshold === undefined
            || assignment.highInventoryThreshold === null
            || assignment.highInventoryThreshold === this.props.initialValues.highInventoryThreshold
          ) {
            this.props.change(
              `assignments.${assignment.ownerId}.highInventoryThreshold`,
              this.props.highInventoryThreshold
            );
          }
        });
      }

      if (this.props.initialValues.lowInventoryThreshold !== this.props.lowInventoryThreshold) {
        this.props.product.assignments.forEach((assignment) => {
          if (
            assignment.lowInventoryThreshold === undefined
            || assignment.lowInventoryThreshold === null
            || assignment.lowInventoryThreshold === this.props.initialValues.lowInventoryThreshold
          ) {
            this.props.change(
              `assignments.${assignment.ownerId}.lowInventoryThreshold`,
              this.props.lowInventoryThreshold
            );
          }
        });
      }
    },
  })
);

export default InventoryStepContainer;
